import React, { Component } from "react";
import {
  Card,
  Button,
  FormInput,
  FormSelect,
  FormTextarea,
  FormRadio,
  Loader,
} from "ui-kit-ck-consultant";
import { Row, Col } from "react-flexbox-grid";

import AuthContext from "../../context/AuthContext";
import axiosConfig from "../../utils/axiosConfig";

export default class Declare extends Component {
  constructor(props) {
    super(props);
    this.state = {
      isLoad: false,
      step: 0, // 0: type selection, 1: folder reference, 2: anomaly data
      type: "", // "expert" or "assistant"
      // Deep-link prefill (e.g. from SLA Report: /anomaly?ref=...&type=...)
      pendingReference: "",
      // Step 1 - Folder
      reference: "",
      folderData: null,
      // User options
      userOptions: [],
      userId: "",
      // Options
      anomalyNotedOptions: [],
      anomalyOriginOptions: [],
      anomalyExpertiseTypeOptions: [],
      // Step 2 - Anomaly data
      anomalieReleveeId: "",
      origineId: "",
      typeExpertiseId: "",
      incidentMateriel: "",
      impactFinancierCompagnie: "",
      impactFinancierCabinet: "",
      commentaire: "",
      solution: "",
    };

    // Anomalies filtrées pour assistant
    this.assistantExcludedAnomalies = [
      "Anomalie identification",
      "Anomalie imputation",
      "Anomalie chiffrage",
      "Anomalie expertale",
    ];
  }

  static contextType = AuthContext;

  // Deep-link support: /anomaly?ref=<folder>&type=expert|assistant pre-fills the
  // folder reference (and skips straight to step 2 when the type is provided).
  componentDidMount() {
    const params = new URLSearchParams(window.location.search);
    const ref = params.get("ref");
    const type = params.get("type");
    if (ref) {
      this.setState({ pendingReference: ref });
      if (type === "expert" || type === "assistant") {
        this.handleSelectType(type);
      }
    }
  }

  loadOptions = () => {
    axiosConfig("anomaly/get-options").then((res) => {
      if (res.data.success === true) {
        let anomalyNotedOptions = res.data.anomalyNoted || [];
        if (this.state.type === "assistant") {
          anomalyNotedOptions = anomalyNotedOptions.filter(
            (opt) => !this.assistantExcludedAnomalies.includes(opt.text),
          );
        }
        this.setState({
          anomalyNotedOptions,
          anomalyOriginOptions: res.data.anomalyOrigin || [],
          anomalyExpertiseTypeOptions: res.data.anomalyExpertiseType || [],
        });
      }
    });
  };

  loadUsers = () => {
    const userType = this.state.type === "expert" ? [1, 2, 3] : [4, 5];
    axiosConfig("anomaly/get-users", {
      data: { userType },
    }).then((res) => {
      if (res.data.success === true) {
        this.setState({ userOptions: res.data.data || [] });
      }
    });
  };

  handleSelectType = (type) => {
    this.setState({ type, step: 1 }, () => {
      this.loadOptions();
      this.loadUsers();
      // If a reference was passed via deep-link, search it and jump to step 2.
      if (this.state.pendingReference) {
        this.setState(
          { reference: this.state.pendingReference, pendingReference: "" },
          () => this.handleSearchFolder(),
        );
      }
    });
  };

  handleSearchFolder = () => {
    if (!this.state.reference) return;
    this.setState({ isLoad: true }, () => {
      axiosConfig("anomaly/get-folder", {
        data: { reference: this.state.reference },
      }).then((res) => {
        if (res.data.success === true) {
          const folder = res.data.data;
          const userId =
            this.state.type === "expert"
              ? folder.expert || ""
              : folder.assistant || "";
          this.setState({
            isLoad: false,
            folderData: folder,
            userId: userId.toString(),
            step: 2,
          });
        } else {
          this.setState({ isLoad: false, folderData: null, step: 2 });
          alert("Dossier non trouvé, vous pouvez continuer sans référence");
        }
      });
    });
  };

  handleSubmit = () => {
    if (
      !this.state.userId ||
      !this.state.origineId ||
      !this.state.anomalieReleveeId
    ) {
      alert("Veuillez remplir tous les champs obligatoires");
      return;
    }

    const formData = {
      ref_folder: this.state.reference,
      "type-expertise": this.state.typeExpertiseId,
      origine: this.state.origineId,
      "anomalie-relevee": this.state.anomalieReleveeId,
      "incident-materiel-expert": this.state.incidentMateriel,
      "impact-financier-compagnie": this.state.impactFinancierCompagnie,
      "impact-financier-cabinet": this.state.impactFinancierCabinet,
      commentaire: this.state.commentaire,
      solution: this.state.solution,
      type: this.state.type,
      user: this.state.userId,
    };

    const data = {
      userId: parseInt(this.state.userId),
      origineId: parseInt(this.state.origineId),
      anomalieReleveeId: parseInt(this.state.anomalieReleveeId),
      typeExpertiseId: this.state.typeExpertiseId
        ? parseInt(this.state.typeExpertiseId)
        : null,
      type: this.state.type,
      dataJSON: JSON.stringify(formData),
      folderId: this.state.folderData ? this.state.folderData.id : null,
      commentaire: this.state.commentaire,
      incidentMateriel: this.state.incidentMateriel,
    };

    this.setState({ isLoad: true }, () => {
      axiosConfig("anomaly/insert-anomaly", {
        data: { data },
      }).then((res) => {
        if (res.data.success === true) {
          alert("Anomalie créée avec succès");
          this.resetForm();
          if (this.props.onInsert) {
            this.props.onInsert();
          }
        } else {
          this.setState({ isLoad: false });
          alert("Une erreur est survenue");
        }
      });
    });
  };

  resetForm = () => {
    this.setState({
      isLoad: false,
      step: 0,
      type: "",
      reference: "",
      folderData: null,
      userOptions: [],
      userId: "",
      anomalyNotedOptions: [],
      anomalyOriginOptions: [],
      anomalyExpertiseTypeOptions: [],
      anomalieReleveeId: "",
      origineId: "",
      typeExpertiseId: "",
      incidentMateriel: "",
      impactFinancierCompagnie: "",
      impactFinancierCabinet: "",
      commentaire: "",
      solution: "",
    });
  };

  renderStep0() {
    return (
      <Row>
        <Col xs={12} md={6} className="mb-10">
          <Button
            outline
            text="Déclarer une anomalie expert"
            onClick={() => this.handleSelectType("expert")}
          />
        </Col>
        <Col xs={12} md={6} className="mb-10">
          <Button
            outline
            text="Déclarer une anomalie assistant(e)"
            onClick={() => this.handleSelectType("assistant")}
          />
        </Col>
      </Row>
    );
  }

  renderStep1() {
    return (
      <>
        <Row>
          <Col xs={12} md={8}>
            <FormInput
              title="Référence dossier"
              name="reference"
              value={this.state.reference}
              onChange={(e) => this.setState({ reference: e.target.value })}
            />
          </Col>
          <Col xs={12} md={4} className="d-flex">
            <Button
              className="mt-auto"
              text="Rechercher"
              onClick={this.handleSearchFolder}
            />
          </Col>
        </Row>
        <Button
          className="mt-10"
          outline
          text="Annuler"
          onClick={this.resetForm}
        />
      </>
    );
  }

  renderStep2() {
    return (
      <>
        {this.state.folderData ? (
          <div className="mb-10 p-10 bg-gray" style={{ borderRadius: 8 }}>
            <p>
              <b>Dossier :</b> {this.state.reference}
              {this.state.folderData.expertName &&
                ` - Expert : ${this.state.folderData.expertName}`}
              {this.state.folderData.assistantName &&
                ` - Assistant(e) : ${this.state.folderData.assistantName}`}
            </p>
          </div>
        ) : null}
        <Row>
          <Col xs={12} md={6}>
            <FormSelect
              className="my-10"
              title={
                this.state.type === "expert" ? "Expert *" : "Assistant(e) *"
              }
              name="userId"
              value={this.state.userId}
              options={this.state.userOptions}
              onChange={(e) => this.setState({ userId: e.target.value })}
              ignore={true}
              init="Sélectionner un utilisateur"
            />
          </Col>
          {this.state.type === "expert" ? (
            <Col xs={12} md={6}>
              <FormSelect
                className="my-10"
                title="Type d'expertise"
                name="typeExpertiseId"
                value={this.state.typeExpertiseId}
                options={this.state.anomalyExpertiseTypeOptions}
                onChange={(e) =>
                  this.setState({ typeExpertiseId: e.target.value })
                }
                ignore={true}
                init="Sélectionner un type"
              />
            </Col>
          ) : null}
        </Row>
        <Row>
          <Col xs={12} md={6}>
            <FormSelect
              className="my-10"
              title="Origine de l'anomalie *"
              name="origineId"
              value={this.state.origineId}
              options={this.state.anomalyOriginOptions}
              onChange={(e) => this.setState({ origineId: e.target.value })}
              ignore={true}
              init="Sélectionner une origine"
            />
          </Col>
          <Col xs={12} md={6}>
            <FormSelect
              className="my-10"
              title="Anomalie relevée *"
              name="anomalieReleveeId"
              value={this.state.anomalieReleveeId}
              options={this.state.anomalyNotedOptions}
              onChange={(e) =>
                this.setState({ anomalieReleveeId: e.target.value })
              }
              ignore={true}
              init="Sélectionner une anomalie"
            />
          </Col>
        </Row>
        <Row>
          <Col xs={12}>
            <p className="mt-10 mb-5">
              <b>Incident matériel</b>
            </p>
            <FormRadio
              className="my-5"
              text="Informatique"
              name="incidentMateriel"
              value="informatique"
              checked={this.state.incidentMateriel === "informatique"}
              onChange={() =>
                this.setState({ incidentMateriel: "informatique" })
              }
            />
            <FormRadio
              className="my-5"
              text="Véhicule"
              name="incidentMateriel"
              value="vehicule"
              checked={this.state.incidentMateriel === "vehicule"}
              onChange={() => this.setState({ incidentMateriel: "vehicule" })}
            />
            <FormRadio
              className="my-5"
              text="Autre"
              name="incidentMateriel"
              value="autre"
              checked={this.state.incidentMateriel === "autre"}
              onChange={() => this.setState({ incidentMateriel: "autre" })}
            />
          </Col>
        </Row>
        <Row>
          <Col xs={12} md={6}>
            <FormInput
              className="my-10"
              title="Impact financier compagnie (€ HT)"
              name="impactFinancierCompagnie"
              type="number"
              value={this.state.impactFinancierCompagnie}
              onChange={(e) =>
                this.setState({ impactFinancierCompagnie: e.target.value })
              }
            />
          </Col>
          <Col xs={12} md={6}>
            <FormInput
              className="my-10"
              title="Impact financier cabinet (€ HT)"
              name="impactFinancierCabinet"
              type="number"
              value={this.state.impactFinancierCabinet}
              onChange={(e) =>
                this.setState({ impactFinancierCabinet: e.target.value })
              }
            />
          </Col>
        </Row>
        <FormTextarea
          className="my-10"
          title="Commentaires"
          name="commentaire"
          value={this.state.commentaire}
          onChange={(e) => this.setState({ commentaire: e.target.value })}
        />
        <FormTextarea
          className="my-10"
          title="Proposition de solutions"
          name="solution"
          value={this.state.solution}
          onChange={(e) => this.setState({ solution: e.target.value })}
        />
        <Row>
          <Col xs={12} md={6}>
            <Button
              className="mt-10"
              text="Valider"
              onClick={this.handleSubmit}
            />
          </Col>
          <Col xs={12} md={6}>
            <Button
              className="mt-10"
              outline
              text="Annuler"
              onClick={this.resetForm}
            />
          </Col>
        </Row>
      </>
    );
  }

  render() {
    return (
      <Card
        className={this.props.className}
        title={
          this.state.step === 0
            ? "Déclarer une anomalie"
            : this.state.type === "expert"
            ? "Anomalie expert"
            : "Anomalie assistant(e)"
        }
      >
        <Loader show={this.state.isLoad} />
        {this.state.step === 0 && this.renderStep0()}
        {this.state.step === 1 && this.renderStep1()}
        {this.state.step === 2 && this.renderStep2()}
      </Card>
    );
  }
}
